export default class FormattedNumber
  constructor: (number) ->
    @number = number
    @money = false
    @isK = false
    @isPercent = false

  centsToDollars: (decimals = 2) ->
    @moneyDecimals = decimals
    @money = true
    @number = @round(parseFloat(@number / 100), (decimals*-1))
    this

  asK: ->
    if @number >= 1000000
      @isMM = true
      @number = @number / 1000000.00
    else
      @isK = true
      @number = @number / 1000.00
    @number = @round(@number, -2)
    this

  asWholeK: ->
    @asK()
    @number = @round(@number, 0)
    this

  asBigNumber: ->
    @number = @round(@number, 0)
    this

  asPercent: (precision = 0) ->
    @isPercent = true
    @number = @round(parseFloat(@number), (precision*-1))
    this

  asTime: ->
    @time = true
    minutes = Math.floor(@number/60)
    seconds = (@number-minutes*60).toFixed(0)
    @number = minutes.toString()+"m"+seconds.toString()+"s"
    this

  addCommas: ->
    @number = @number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    this

  trimTrailingZeros: ->
    @number = @number.toString().replace(/(\.00$|\.0$)/, "")
    this

  toString: ->
    @number = @number.toFixed(@moneyDecimals) if @money && !@isK
    @addCommas() unless @time
    @trimTrailingZeros() unless @money || @time
    out = ""
    out += "$" if @money
    out += @number
    out += "%" if @isPercent
    out += "K" if @isK
    out += "MM" if @isMM
    out

  # from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/round
  round: (value, exp) ->
    @decimalAdjust 'round', value, exp

  decimalAdjust:  (type, value, exp) ->
    # If the exp is undefined or zero...
    if typeof exp == 'undefined' or +exp == 0
      return Math[type](value)
    value = +value
    exp = +exp
    # If the value is not a number or the exp is not an integer...
    if isNaN(value) or !(typeof exp == 'number' and exp % 1 == 0)
      return NaN
    # Shift
    value = value.toString().split('e')
    value = Math[type](+(value[0] + 'e' + (if value[1] then +value[1] - exp else -exp)))
    # Shift back
    value = value.toString().split('e')
    +(value[0] + 'e' + (if value[1] then +value[1] + exp else exp))

  friendlyFileSize: ->
    return "" unless @number?
    thresh = 1024
    if(@number < thresh)
      return @number + " B"
    units = ["KB","MB","GB","TB","PB","EB","ZB","YB"]
    u = -1
    loop
      @number = @number / thresh
      ++u
      break if(@number <= thresh)
    return @number.toFixed(1)+" "+units[u]



// WEBPACK FOOTER //
// ./app/javascript/utils/platform/formatted_number.js.coffee